var n=function(n,r){return n<2||r<6?[0,5]:n+2<r?[n-2,n+3]:[r-5,r+1]},r=function(n,r,t){return r<5||[n-1,n,n+1].includes(t)||0===n&&2===t||n===r-1&&t===n-2?"big":"small"};export{r as getDotSizeClass,n as getDotsScope};
